module.exports = __webpack_public_path__ + "img/Information.5328501a.svg";